import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';
import type RouterService from '@ember/routing/router-service';
import type StoreService from 'scaleflow/services/store';
import connectors from 'scaleflow/utils/connectors-config';

class ConnectorsSuccessRoute extends Route {
  @service declare store: StoreService;
  @service declare router: RouterService;

  beforeModel() {
    return this.store.findAll('integration-setting', { reload: true });
  }

  model({ connector_id }: { connector_id: string }) {
    const connector = connectors.find((c) => c.id === connector_id);
    if (!connector) {
      this.router.replaceWith('404');
      return;
    }
    return connector;
  }
}

export default instrumentRoutePerformance(ConnectorsSuccessRoute);
